module.exports = __webpack_public_path__ + "static/media/neutral-face.e61d034f.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/neutral-face.png
// module id = 671
// module chunks = 1